<template>
  <div>
    <section class="choose py-5" id="choose">
      <div class="container py-md-3">
        <h3 class="heading mb-5 text-center" data-aos="zoom-in">
          Pourquoi nous choisir
        </h3>
        <div class="feature-grids row">
          <div class="col-lg-4 col-md-6" data-aos="fade-right">
            <div class="f1 icon1 p-4">
              <span
                style="background-color: #f3f3f3; padding: 20px 10px 27px 10px"
              >
                <img src="images/et.png" style="height: 50px" alt="" />
              </span>
              <h3 class="my-3">Expertise Technique</h3>
              <p>
                Nous disposons d'une équipe d'experts en développement de
                logiciels. Notre équipe possède une vaste expérience dans le
                développement de logiciels sur mesure, la programmation, et la
                maîtrise des dernières technologies.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6" data-aos="fade-up">
            <div class="f1 icon2 p-4">
              <span
                style="background-color: #f3f3f3; padding: 20px 10px 27px 10px"
              >
                <img src="images/sp.png" style="height: 50px" alt="" />
              </span>
              <h3 class="my-3">Solutions Personnalisées</h3>
              <p>
                Nous créons des solutions sur mesure adaptées aux besoins
                spécifiques de chaque client. Nous travaillons en étroite
                collaboration avec nos clients pour comprendre leurs objectifs
                et offrir des solutions qui répondent à leurs besoins.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-lg-0 mt-4" data-aos="fade-left">
            <div class="f1 icon3 p-4">
              <span
                style="background-color: #f3f3f3; padding: 20px 10px 27px 10px"
              >
                <img src="images/qf.png" style="height: 50px" alt="" />
              </span>
              <h3 class="my-3">Qualité et Fiabilité</h3>
              <p>
                Nous nous engageons envers nos clients à fournir des projets de
                qualité et de fiabilité. Nous effectuons des tests rigoureux
                pour garantir que nos logiciels sont robustes, performants et
                exempts de bugs.
              </p>
            </div>
          </div>
        </div>

        <div class="feature-grids row">
          <div class="col-lg-4 col-md-6" data-aos="fade-right">
            <div class="f1 icon1 p-4">
              <span
                style="background-color: #f3f3f3; padding: 20px 10px 27px 10px"
              >
                <img src="images/sec.jpg" style="height: 50px" alt="" />
              </span>
              <h3 class="my-3">Sécurité des Données</h3>
              <p>
                Nous disposons d'une large expertise en matière de sécurité
                informatique. Nous intégrons des mesures de sécurité avancées
                dans nos logiciels pour protéger les données sensibles de nos
                clients.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6" data-aos="fade-up">
            <div class="f1 icon2 p-4">
              <span
                style="background-color: #f3f3f3; padding: 20px 10px 27px 10px"
              >
                <img src="images/delais.webp" style="height: 50px" alt="" />
              </span>
              <h3 class="my-3">Respect des Délais</h3>
              <p>
                Nous avons une grande expérience qui assure notre capacité à
                respecter les délais. Nous livrons les projets des nos clients à
                temps, ce qui permet à nos Clients de planifier efficacement.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-lg-0 mt-4" data-aos="fade-left">
            <div class="f1 icon3 p-4">
              <span
                style="background-color: #f3f3f3; padding: 20px 10px 27px 10px"
              >
                <img src="images/support.webp" style="height: 50px" alt="" />
              </span>
              <h3 class="my-3">Support Continu</h3>
              <p>
                Nous suivons nos clients après déploiement du logiciel. Nous
                offrons un suivi de maintenance et de mises à jour
                pour garantir que le logiciel reste opérationnel et évolue avec
                les besoins changeants de l'entreprise.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Choose-Item",
};
</script>

<style scoped>
</style>